<template>
  <div class="content">
    <div class="reset-wrapper">
      <div class="reset">
        
        <h3>Password Reset</h3>
        <h4 v-if='isLoggedIn'>YOU CANNOT ACCESS THIS PAGE WHILE LOGGED IN. PLEASE LOG OUT AND RE-OPEN THE LINK TO ACCESS.</h4>
        <form @submit.prevent="handleResetPassword" class="form" ref="formContainer">

          <div v-if="!form.email" class="b-form-group form-group" role="group">
            <label class="col-form-label pt-0">Email: </label>
            <input :disabled='isLoggedIn || isSubmitting' id="email" type="text"
                   v-model="form.email"
                   class="form-control form__input"
                   required>
          </div>

          <div v-if="!form.token" class="b-form-group form-group" role="group">
            <label class="col-form-label pt-0">Token: </label>
            <input :disabled='isLoggedIn || isSubmitting' id="token" type="text"
                   v-model="form.token"
                   class="form-control form__input"
                   required>
          </div>

          <div class="b-form-group form-group" role="group">
            <label class="col-form-label pt-0">New Password: </label>
            <input :disabled='isLoggedIn || isSubmitting' id="password"
                   v-model="form.password"
                   class="form-control form__input"
                   required
                   type="password"
                   placeholder="Enter new password"
                   @change="validatePassword">
            <form-error :errors="formErrors.password"/>
          </div>

          <div class="b-form-group form-group" role="group" id="exampleInputGroup2">
            <label class="col-form-label pt-0">Confirm Password: </label>
            <input :disabled='isLoggedIn || isSubmitting' id="password2"
                   v-model="form.password2"
                   class="form-control form__input"
                   required
                   type="password"
                   placeholder="Confirm password"
                   @change="confirmPassword">
            <form-error :errors="formErrors.password2"/>
          </div>

          <div class="button-group">
            <button
              type="submit"
              class="col-md-12 col-12 btn btn--reset"
              :disabled="isSubmitting"
            >
              {{ isSubmitting ? 'One moment...' : 'Reset Password' }}
            </button>
            <router-link to="/login" class="form__link">Back to login</router-link>
            <div v-bind:class="messageClass" v-html="statusMessage"></div>
          </div>
        </form>
      </div>

    </div>
  </div>

</template>

<script>
import {
  resetPassword
} from '@/api/userApi';
import {
  PASSWORD_RESET_SUCCESS_MESSAGE,
  TOKEN_MISMATCH_MESSAGE,
  TOKEN_EXIPRED_MESSAGE,
  NO_SUCH_USER_MESSAGE,
  PASSWORD_IN_USE_MESSAGE,
  WRONG_PASSWORD_FORMAT_MESSAGE 
} from '@/api/ajaxActionResponse';
import FormError from './register/FormError';
import VALIDATION_ERRORS from '@/data/validationErrors';
import { getPasswordPolicyErrors } from '@/utils/passwordPolicy';
import {
  LoginNavigation
} from '@/store/modules/fsm/messages';
import router from '@/router/index';

export default {
  name: 'reset-password-page',
  data() {
    return {
      form: {
        email: '',
        token: '',
        password: '',
        password2: ''
      },
      formErrors: {},
      statusMessage: '',
      isSubmitting: false
    }
  },
  components: {
    'form-error': FormError,
  },
  computed: {
    messageClass: function() {
      return this.statusMessage.length === 0 ? 'd-none' : 'alert alert-warning';
    },
    isLoggedIn: function() {
        let isLoggedIn = store.getters['login/isLoggedIn'];
        return isLoggedIn;
    }
  },
  beforeCreate() {
    window.sessionStorage.triedToResetPassword = Date.now();
    if(this.isLoggedIn) {
      alert('Please logout to reset password');
      router.push({name:LoginNavigation});
    }
    let isInit = this.$gotInitialMessage();
    if(!isInit)
    {
      let href = location.href + '';
      setTimeout(() => location.assign(href),5000);
    }
  },
  created() {
    const routeEmail = this.$route.query['email'];
    const routeToken = this.$route.query['token'];
    let usedLocationSearchFallback = false;
    if (routeEmail && routeToken) {
      this.form.email = routeEmail;
      this.form.token = routeToken;
    } else {
      // Some email clients preserve query params before #/reset.
      const searchParams = new URLSearchParams(window.location.search || '');
      const locationEmail = searchParams.get('email');
      const locationToken = searchParams.get('token');
      if (locationEmail && locationToken) {
        this.form.email = locationEmail;
        this.form.token = locationToken;
        usedLocationSearchFallback = true;
      }
    }
    if (usedLocationSearchFallback && window.history && window.history.replaceState) {
      const normalizedHash = '#/reset?email='
        + encodeURIComponent(this.form.email)
        + '&token='
        + encodeURIComponent(this.form.token);
      // Remove ?reset=1&email=...&token=... from base URL so it doesn't persist across routes.
      window.history.replaceState({}, document.title, window.location.pathname + normalizedHash);
    }
    // initialize errors
    for (let key in this.form) {
      // this.$set(this.formErrors, key, []);
      this.formErrors[key] = []
    }
  },
  methods: {
    handleResetPassword() {
      if(this.isLoggedIn || this.isSubmitting)
        return;
      this.isSubmitting = true;
      resetPassword(this.form)
      .then((data) => {
          this.statusMessage = '';
          alert('Success! You can now log in using your new password.');
          router.push({name:LoginNavigation});
      })
      .catch((err) => {
        this.statusMessage = err;
      })
      .finally(() => {
        this.isSubmitting = false;
      });

    },
    validatePassword() {
      this.formErrors.password = getPasswordPolicyErrors(this.form.password);

      if (this.form.password2 
      && this.form.password2 !== '') {
        this.confirmPassword();
      }
    },
    confirmPassword() {
      this.formErrors.password2 = [];
      if (this.form.password !== this.form.password2) {
        this.formErrors.password2.push(VALIDATION_ERRORS.PASSWORD_MISMATCH);
      }
    },
  }
}
</script>

<style scoped lang="scss">
  @import "../../stylesheets/mixins/alignment";
  $color-base: #0060ff;
  .content {
    width: 100%;
    height: auto;
    background: url("../../assets/images/bg.jpg") no-repeat center fixed;     // TODO image subject to copyright
    background-size: cover;
    position: relative;
  }
  .reset-wrapper {
    height: 100vh;
    width: 100%;
    position: relative;
  }

  .reset {
    background-color: #fff;
    padding: 2.0rem;
    -moz-box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2);
    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2);

    @include absoluteCenter(380px);
  }
  .reset__introduction {
    color: darken(gray, 10%);
    font-size: 14px;
    text-align: center;
  }
  .btn--reset {
    color: #fff;
    background-color: $color-base;
    &:hover {
      background-color: lighten($color-base, 5%);
    }
  }

  .button-group {
    margin-top: 1.5rem;

    .form__link {
      color: $color-base;
      font-size: 0.85rem;
      margin-top: 0.5rem;
      display: block;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .form__input {
    font-size: 0.85rem;
  }
  .col-form-label {
    font-size: 14px;
  }

  @media only screen and (max-width: 468px) {
    .reset {
      width: 100%;
    }
  }
</style>
